import http from '@/requests/http'
import appConfig from '@/config/app'
import utilityHelper from '@/helpers/utils'

class User {
  static all (params) {
    return http.post('users/index', params)
  }
  static async view (params) {
    return http.post('users/view', params)
  }
  static async update (data) {
    return http.post('users/update', data)
  }
  static async save (data) {
    const formData = new FormData()

    await utilityHelper.buildFormData(formData, data)

    return http.post('users/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static async export () {
    window.open(`${appConfig.apiBaseUrl  }/users/export`, '_blank')
  }
  static async destroy (params) {
    return http.post('users/destroy', params)
  }
  static async showAgentName (params) {
    return http.post('users/show-agent-name', params)
  }
  static async showAgentNames (params) {
    return http.post('users/show-agent-names', params)
  }
  static async checkUser () {
    return http.post('users/check-user')
  }
  static async viewPermission (params) {
    return http.post('users/view-permission', params)
  }
  static async updatePermission (data) {
    return http.post('users/update-permission', data)
  }
  static async updateStatus (data) {
    return http.post('users/update-status', data)
  }
  static async updateQueueReportStatus (data) {
    return http.post('users/update-queue-report-status', data)
  }
  static async resetPassword (params) {
    return http.post('users/reset-password', params)
  }
  static async getExtensions (params) {
    return http.post('users/extensions', params)
  }
  static async getUserUsedExtensions (params) {
    return http.post('users/used-extensions', params)
  }
  static loginViaApiKey (agentApiKey) {
    return http.post('user/login', {agentApiKey})
  }
}

export default User
